"use strict";

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
      }
    };
    return _extendStatics(d, b);
  };
  return function (d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    _extendStatics(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
var __generator = this && this.__generator || function (thisArg, body) {
  var _ = {
      label: 0,
      sent: function sent() {
        if (t[0] & 1) throw t[1];
        return t[1];
      },
      trys: [],
      ops: []
    },
    f,
    y,
    t,
    g;
  return g = {
    next: verb(0),
    "throw": verb(1),
    "return": verb(2)
  }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
    return this;
  }), g;
  function verb(n) {
    return function (v) {
      return step([n, v]);
    };
  }
  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");
    while (_) {
      try {
        if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
        if (y = 0, t) op = [op[0] & 2, t.value];
        switch (op[0]) {
          case 0:
          case 1:
            t = op;
            break;
          case 4:
            _.label++;
            return {
              value: op[1],
              done: false
            };
          case 5:
            _.label++;
            y = op[1];
            op = [0];
            continue;
          case 7:
            op = _.ops.pop();
            _.trys.pop();
            continue;
          default:
            if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
              _ = 0;
              continue;
            }
            if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
              _.label = op[1];
              break;
            }
            if (op[0] === 6 && _.label < t[1]) {
              _.label = t[1];
              t = op;
              break;
            }
            if (t && _.label < t[2]) {
              _.label = t[2];
              _.ops.push(op);
              break;
            }
            if (t[2]) _.ops.pop();
            _.trys.pop();
            continue;
        }
        op = body.call(thisArg, _);
      } catch (e) {
        op = [6, e];
        y = 0;
      } finally {
        f = t = 0;
      }
    }
    if (op[0] & 5) throw op[1];
    return {
      value: op[0] ? op[1] : void 0,
      done: true
    };
  }
};
var __spreadArray = this && this.__spreadArray || function (to, from, pack) {
  if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
    if (ar || !(i in from)) {
      if (!ar) ar = Array.prototype.slice.call(from, 0, i);
      ar[i] = from[i];
    }
  }
  return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
var javascript_sdk_1 = require("@mdap/javascript-sdk");
var log_1 = require("@mdap/javascript-sdk/lib/utils/log");
var historyListner_1 = require("./historyListner");
var isErrorObject = function isErrorObject(error) {
  return error instanceof Error;
};
var stackMessageRegex = {
  chrome: /^(.*)\n\s+(at)/,
  safari: /^(.*)\/<@/
};
var preProcessStack = function preProcessStack(value) {
  if (!value) {
    return '';
  }
  var result = value;
  for (var _i = 0, _a = Object.values(stackMessageRegex); _i < _a.length; _i++) {
    var rule = _a[_i];
    if (rule.test(value)) {
      result = value.replace(rule, '$2');
      break;
    }
  }
  return result;
};
// 默认一分钟检测上报
var DEFAULT_CHECK_INTERVAL = 60000;
var stringifyOriginalException = function stringifyOriginalException(error) {
  if (!error) {
    return '';
  }
  if (typeof error === 'string') {
    return error;
  }
  try {
    if (isErrorObject(error)) {
      // convert Error into object
      var result_1 = {};
      Object.getOwnPropertyNames(error).forEach(function (key) {
        result_1[key] = error[key];
      });
      return JSON.stringify(result_1);
    }
    return JSON.stringify(error);
  } catch (error) {
    //
    return '';
  }
};
var isMatchArray = function isMatchArray(value) {
  return Array.isArray(value);
};
var ExceptionPlugin = /** @class */function (_super) {
  __extends(ExceptionPlugin, _super);
  function ExceptionPlugin(config) {
    var _this = _super.call(this, config) || this;
    _this.interval = DEFAULT_CHECK_INTERVAL;
    _this.reportAtInterval = false;
    _this.type = 'exception';
    _this.delegateReporter = true;
    _this.reportDatas = [];
    if (typeof (config === null || config === void 0 ? void 0 : config.interval) === 'number') {
      _this.interval = config.interval;
    }
    _this.reportAtInterval = (config === null || config === void 0 ? void 0 : config.mode) === 'interval';
    _this.path = config === null || config === void 0 ? void 0 : config.path;
    return _this;
  }
  ExceptionPlugin.trackError = function (event, error) {
    if (!Object.keys(ExceptionPlugin.TRIGGER_MAPS).length) {
      return;
    }
    try {
      var exception = error;
      if (!exception) {
        exception = typeof event === 'string' ? {
          name: 'ErrorEvent',
          message: event
        } : {
          name: event.type,
          message: 'unknown'
        };
      }
      var reportData = {
        timestamp: +new Date(),
        type: 'error',
        level: 'error',
        error_name: exception.name,
        error_message: exception.message,
        error_stack: exception.stack,
        original_exception: stringifyOriginalException(exception)
      };
      reportData.error_stack = preProcessStack(reportData.error_stack);
      for (var _i = 0, _a = Object.values(ExceptionPlugin.TRIGGER_MAPS); _i < _a.length; _i++) {
        var listener = _a[_i];
        listener.triggerFunction(reportData);
      }
    } catch (error) {
      log_1.Logger.error(error);
    }
  };
  ExceptionPlugin.trackEvent = function (event) {
    var _a;
    if (!Object.keys(ExceptionPlugin.TRIGGER_MAPS).length) {
      return;
    }
    try {
      var stack = undefined;
      var errorMessage = typeof event.reason === 'string' ? event.reason : (_a = event.reason) === null || _a === void 0 ? void 0 : _a.message;
      var errorName = event.type;
      if (event.reason instanceof Error) {
        errorMessage = event.reason.message;
        errorName = event.reason.name;
        stack = event.reason.stack;
      }
      if (!stack && typeof Error.captureStackTrace === 'function') {
        var exception = {
          message: errorMessage
        };
        Error.captureStackTrace(exception);
        stack = exception.stack;
      }
      var reportData = {
        timestamp: +new Date(),
        type: 'unhandledrejection',
        level: 'error',
        error_name: errorName,
        error_message: errorMessage,
        error_stack: stack,
        original_exception: stringifyOriginalException(event.reason)
      };
      reportData.error_stack = preProcessStack(reportData.error_stack);
      for (var _i = 0, _b = Object.values(ExceptionPlugin.TRIGGER_MAPS); _i < _b.length; _i++) {
        var listener = _b[_i];
        listener.triggerFunction(reportData);
      }
    } catch (error) {
      log_1.Logger.error(error);
    }
  };
  ExceptionPlugin.prototype.isPageUrlMatch = function () {
    //
    if (!this.path) {
      return true;
    }
    var path = window.location.href;
    if (isMatchArray(this.path)) {
      var matched = false;
      for (var _i = 0, _a = this.path; _i < _a.length; _i++) {
        var rule = _a[_i];
        if (path.match(rule)) {
          matched = true;
          break;
        }
      }
      return matched;
    }
    return !!path.match(this.path);
  };
  ExceptionPlugin.prototype.register = function (props) {
    var _this = this;
    // 初始化数据
    this.processData();
    var addData = function addData(data) {
      var _a, _b, _c, _d, _e, _f;
      if (!_this.isPageUrlMatch()) {
        return;
      }
      if (!_this.reportDatas.length) {
        _this.processData();
      }
      var reportData = _this.reportDatas[_this.reportDatas.length - 1];
      if (_this.reportAtInterval) {
        // fill report-page-url in data field
        data.data_field = __assign(__assign({}, (_a = data.data_field) !== null && _a !== void 0 ? _a : {}), {
          report_page_url: "".concat(window.location.origin).concat(window.location.pathname)
        });
      }
      if (Object.keys((_c = (_b = _this.reporter) === null || _b === void 0 ? void 0 : _b.tags) !== null && _c !== void 0 ? _c : {}).length) {
        data.data_field = __assign(__assign({}, (_e = (_d = _this.reporter) === null || _d === void 0 ? void 0 : _d.tags) !== null && _e !== void 0 ? _e : {}), (_f = data.data_field) !== null && _f !== void 0 ? _f : {});
      }
      reportData.data.exceptions.push(data);
    };
    this.triggerHandler = addData;
    ExceptionPlugin.TRIGGER_MAPS[props.app_name] = {
      triggerFunction: addData
    };
    this.init(props.app_name);
  };
  // 预处理数据
  ExceptionPlugin.prototype.processData = function () {
    if (!this.reporter) {
      // error message
      return;
    }
    try {
      var result = __assign(__assign({}, this.reporter.commonData), {
        tag: 'web-exception',
        event_timestamp: +new Date(),
        data: __assign(__assign({}, this.reporter.webCommonData), {
          page_url: "".concat(window.location.origin).concat(window.location.pathname),
          exceptions: []
        })
      });
      this.reportDatas.push(result);
      return result;
    } catch (error) {
      log_1.Logger.info('[MDAP] Failed to process exception data');
      log_1.Logger.error(error);
    }
  };
  ExceptionPlugin.prototype.sendData = function () {
    var _a;
    return __awaiter(this, void 0, void 0, function () {
      var currentRecord, reportDatas, error_1;
      return __generator(this, function (_b) {
        switch (_b.label) {
          case 0:
            if (!this.reporter) {
              return [2 /*return*/];
            }

            currentRecord = (_a = this.reportDatas) === null || _a === void 0 ? void 0 : _a.pop();
            _b.label = 1;
          case 1:
            _b.trys.push([1, 5,, 6]);
            reportDatas = __spreadArray([], this.reportDatas, true);
            if (currentRecord) {
              this.reportDatas = [currentRecord];
            }
            if (!(this.reportDatas.length === 1 && currentRecord)) return [3 /*break*/, 3];
            return [4 /*yield*/, this.reporter.sendData(reportDatas[0])];
          case 2:
            _b.sent();
            return [2 /*return*/];
          case 3:
            return [4 /*yield*/, this.reporter.sendBulkData(reportDatas)];
          case 4:
            _b.sent();
            return [3 /*break*/, 6];
          case 5:
            error_1 = _b.sent();
            log_1.Logger.error(error_1);
            return [3 /*break*/, 6];
          case 6:
            return [2 /*return*/];
        }
      });
    });
  };

  ExceptionPlugin.prototype.cacheData = function () {
    var _a;
    (_a = this.reporter) === null || _a === void 0 ? void 0 : _a.offlineStore.cacheData(this.reportDatas);
    this.reportDatas = [];
  };
  ExceptionPlugin.prototype.check = function () {
    var _a;
    try {
      if (this.reportAtInterval) {
        var reportDatas = this.reportDatas.filter(function (data) {
          return data.data.exceptions.length;
        });
        if (!reportDatas.length || !((_a = reportDatas[0]) === null || _a === void 0 ? void 0 : _a.data.exceptions.length)) {
          return;
        }
        this.processData();
      }
      if (this.reportDatas.length > 1) {
        this.sendData();
      }
    } catch (error) {
      log_1.Logger.warn('[MDAP] failed to process report datas.');
      log_1.Logger.error(error);
    }
  };
  ExceptionPlugin.prototype.start = function () {
    var _this = this;
    setInterval(function () {
      _this.check();
    }, this.interval);
  };
  /* init listener & override onerror / unhandledrejection */
  ExceptionPlugin.prototype.init = function (app_name) {
    var _this = this;
    try {
      if (!this.reportAtInterval) {
        // report event when history changed - for crash rate calc
        var onHistoryChange = function onHistoryChange(event) {
          if (event === 'beforeunload') {
            // 将现有记录存入本地缓存
            _this.cacheData();
          } else {
            // 添加新的页面记录
            _this.processData();
          }
        };
        var listener = new historyListner_1.HistoryListener();
        listener.add(app_name, onHistoryChange);
      }
      this.start();
      if (ExceptionPlugin.filled) {
        return;
      }
      this.trackGlobalError();
      this.trackUnhandledRejection();
      ExceptionPlugin.filled = true;
    } catch (error) {
      log_1.Logger.info('[MDAP] Failed to init exception plugin');
      log_1.Logger.error(error);
    }
  };
  ExceptionPlugin.prototype.trackGlobalError = function () {
    var originalErrorHandler = window.onerror;
    global.onerror = function (event, source, lineno, colno, error) {
      // trigger
      ExceptionPlugin.trackError(event, error);
      if (typeof originalErrorHandler === 'function') {
        /* eslint-disable-next-line prefer-rest-params, @typescript-eslint/no-explicit-any */
        return originalErrorHandler.apply(this, arguments);
      }
      return false;
    };
  };
  ExceptionPlugin.prototype.trackUnhandledRejection = function () {
    var originalRejectionHanlder = window.onunhandledrejection;
    global.onunhandledrejection = function (evt) {
      ExceptionPlugin.trackEvent(evt);
      if (typeof originalRejectionHanlder === 'function') {
        /* eslint-disable-next-line prefer-rest-params, @typescript-eslint/no-explicit-any */
        return originalRejectionHanlder.apply(window, arguments);
      }
      return true;
    };
  };
  ExceptionPlugin.prototype.capture = function (data) {
    var _a, _b, _c;
    if (typeof this.triggerHandler !== 'function') {
      log_1.Logger.warn('[MDAP] capture - triggerhandler not exist');
      return;
    }
    // 获取自定义上报数据
    var _d = data !== null && data !== void 0 ? data : {},
      error = _d.error,
      message = _d.message,
      extraData = _d.data;
    if (!error && !message) {
      log_1.Logger.info('[MDAP] error / message cannot be empty at the same time');
      return;
    }
    try {
      var stack = '';
      var errorMessage = message !== null && message !== void 0 ? message : '';
      var errorName = (_a = extraData === null || extraData === void 0 ? void 0 : extraData.name) !== null && _a !== void 0 ? _a : '';
      if (isErrorObject(error)) {
        stack = error.stack;
        errorMessage = (_b = errorMessage + error.message) !== null && _b !== void 0 ? _b : '';
        errorName = (_c = errorName + error.name) !== null && _c !== void 0 ? _c : '';
      } else if (!errorMessage && typeof error === 'string') {
        errorMessage = error;
      }
      if (!stack) {
        // generate stack trace
        stack = new Error(errorMessage).stack;
      }
      var reportData = {
        timestamp: +new Date(),
        type: 'custom',
        level: (extraData === null || extraData === void 0 ? void 0 : extraData.level) || 'error',
        error_name: errorName || 'error',
        error_message: errorMessage,
        error_stack: stack,
        original_exception: stringifyOriginalException(error),
        data_field: extraData === null || extraData === void 0 ? void 0 : extraData.data_field,
        extra: extraData === null || extraData === void 0 ? void 0 : extraData.extra
      };
      reportData.error_stack = preProcessStack(reportData.error_stack);
      this.triggerHandler(reportData);
    } catch (error) {
      log_1.Logger.error(error);
    }
  };
  ExceptionPlugin.filled = false;
  ExceptionPlugin.TRIGGER_MAPS = {};
  return ExceptionPlugin;
}(javascript_sdk_1.BasePlugin);
exports.default = ExceptionPlugin;